module.exports = __webpack_public_path__ + "img/sourcing.9fd880f.jpg";